import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import logo from '../../assets/logo.png';

const irA = (id) => {
  const el = document.getElementById(id);
  if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 70, behavior: 'smooth' });
};

const Footer = () => (
  <footer
    style={{
      background: '#07101c',
      borderTop: '1px solid rgba(46,139,192,0.2)',
      padding: '60px 0 30px',
    }}
  >
    <Container>
      <Row className="g-4 g-lg-5 mb-5 justify-content-between">
        {/* Columna marca */}
        <Col lg={4} md={12} className="mb-2 mb-lg-0">
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '1.1rem' }}>
            <img src={logo} alt="W" style={{ height: '46px', width: 'auto' }} />
            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15 }}>
              <span style={{
                fontFamily: 'var(--font-heading)', fontWeight: 700, fontSize: '1.2rem',
                color: '#ffffff', letterSpacing: '-0.3px',
              }}>Web Fácil</span>
              <span style={{
                fontFamily: 'var(--font-heading)', fontWeight: 500, fontSize: '0.72rem',
                color: '#3ea0d7', letterSpacing: '1.5px', textTransform: 'uppercase',
              }}>Castellón</span>
            </div>
          </div>
          <p style={{ color: '#6a86a8', fontSize: '0.93rem', lineHeight: 1.75, maxWidth: '300px' }}>
            Creamos tu presencia digital en Castellón con rapidez, calidad y sin complicaciones. Tu negocio, en internet.
          </p>
        </Col>

        {/* Columna navegación */}
        <Col lg={3} md={6}>
          <h6 style={{ color: '#e8edf5', fontFamily: 'var(--font-heading)', fontWeight: 600, marginBottom: '1.2rem', letterSpacing: '0.8px', fontSize: '0.8rem', textTransform: 'uppercase' }}>
            Navegación
          </h6>
          {[
            { id: 'servicios', label: 'Servicios' },
            { id: 'proceso',   label: 'Cómo trabajamos' },
            { id: 'precios',   label: 'Presupuesto' },
            { id: 'faq',       label: 'Preguntas frecuentes' },
            { id: 'contacto',  label: 'Contacto' },
          ].map(({ id, label }) => (
            <div key={id} style={{ marginBottom: '0.6rem' }}>
              <button
                onClick={() => irA(id)}
                style={{
                  background: 'none', border: 'none', padding: 0,
                  color: '#6a86a8', fontSize: '0.92rem', cursor: 'pointer',
                  transition: 'color 0.2s', fontFamily: 'var(--font-body)',
                }}
                onMouseEnter={e => e.currentTarget.style.color = '#45a8e0'}
                onMouseLeave={e => e.currentTarget.style.color = '#6a86a8'}
              >
                {label}
              </button>
            </div>
          ))}
        </Col>

        {/* Columna contacto */}
        <Col lg={4} md={6}>
          <h6 style={{ color: '#e8edf5', fontFamily: 'var(--font-heading)', fontWeight: 600, marginBottom: '1.2rem', letterSpacing: '0.8px', fontSize: '0.8rem', textTransform: 'uppercase' }}>
            Contacto
          </h6>
          {[
            { icon: 'fa-solid fa-location-dot', text: 'Castellón de la Plana, España' },
            { icon: 'fa-solid fa-envelope',      text: 'info@webfacilcastellon.es' },
            { icon: 'fa-solid fa-phone',         text: '621 06 10 16' },
          ].map(({ icon, text }) => (
            <div key={text} className="d-flex gap-3 mb-2 align-items-start" style={{ color: '#6a86a8', fontSize: '0.9rem' }}>
              <i className={icon} style={{ color: '#2e8bc0', width: '16px', marginTop: '3px', flexShrink: 0 }} />
              <span>{text}</span>
            </div>
          ))}
        </Col>
      </Row>

      <div style={{ borderTop: '1px solid rgba(255,255,255,0.06)', paddingTop: '24px', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: '12px' }}>
        <p style={{ color: '#2e3f52', fontSize: '0.83rem', margin: 0, fontFamily: 'var(--font-body)' }}>
          © {new Date().getFullYear()} Web Fácil Castellón. Todos los derechos reservados.
        </p>
        <div style={{ display: 'flex', gap: '20px' }}>
          {['Política de privacidad', 'Aviso legal', 'Cookies'].map(item => (
            <a
              key={item} href="#"
              style={{ color: '#2e3f52', fontSize: '0.83rem', textDecoration: 'none', transition: 'color 0.2s', fontFamily: 'var(--font-body)' }}
              onMouseEnter={e => e.currentTarget.style.color = '#6a86a8'}
              onMouseLeave={e => e.currentTarget.style.color = '#2e3f52'}
            >
              {item}
            </a>
          ))}
        </div>
      </div>
    </Container>
  </footer>
);

export default Footer;
